import React, { useRef, useState } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Label,
  Input,
  Container,
  Row,
  Col,
  Button,
  Collapse,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Table,
} from "reactstrap";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Select, { components } from "react-select";
import AdminHeader from "components/Headers/AdminHeader";
import { useNavigate } from "react-router-dom";
import {
  COURSE_CATEGORY,
  COURSE_LEVELS,
  COURSE_LANGUAGES,
  REQUIRED_DOCUMENTS,
  ADD_NEW_DOC_OPTION,
  COMPLETION_CRITERIA,
  VALIDITY,
  ADD_NEW_VALIDITY_OPTION,
  OFFLINE_TRAINING_CENTER,
  CRITERIA_DEPENDENT_OPTIONS,
  MODULES,
  ADD_NEW_COURSE,
  coursesList,
} from "components/constant";
import {
  SELECT_CUSTOM_STYLES,
  REGEX,
  MAX_THUMBNAIL_IMG_SIZE,
} from "constants/CommonConstants";
import AddDocumentModal from "./AddDocumentModal";
import CertificateTemplateModal from "./CertificateTemplateModal";
import LessonsSection, { lessons } from "./LessonSection";
import InfoPopover from "components/CommonComponents/InfoPopover";

export const initialState = {
  courseName: {
    value: "",
    error: "",
  },
  category: {
    value: "",
    error: "",
  },
  courseMedia: {
    value: null, //video/image
    error: "",
  },
  courseDescription: {
    value: "",
    error: "",
  },
  publishCourse: {
    // YES | NO
    value: "",
    error: "",
  },
  courseFor: {
    // EXTERNAL | RAYCHEM | BOTH
    value: "",
    error: "",
  },
  level: {
    value: "",
    error: "",
  },
  assessmentType: {
    value: "OFFLINE",
    error: "",
  },
  accessType: {
    // PAID | FREE
    value: "",
    error: "",
  },
  paidFor: {
    // EXTERNAL | RAYCHEM | BOTH
    value: "",
    error: "",
  },
  courseType: {
    // RECORDED | LIVE
    value: "LIVE",
    error: "",
  },
  liveCourseType: {
    value: "OFFLINE",
    error: "",
  },
  maxParticipant: {
    value: "",
    error: "",
  },
  minParticipant: {
    value: "",
    error: "",
  },
  assesmentType: {
    //Technical / Technical+ Practical
    value: "TECHNICAL_PRACTICAL",
    error: "",
  },
  address: {
    value: "",
    error: "",
  },
  coursePrice: {
    value: "",
    error: "",
  },
  courseLanguage: {
    value: [],
    error: "",
  },
  instructorName: {
    value: "",
    error: "",
  },
  preRequisites: {
    value: "",
    error: "",
  },
  requiredDoc: {
    value: [],
    error: "",
  },
  notes: {
    value: "",
    error: "",
  },
  certificateEnabled: {
    //YES | NO
    value: "",
    error: "",
  },
  completionCriteria: {
    value: [], //array
    error: "",
  },
  criteriaValue: {
    value: {}, //object
    error: "",
  },
  validity: {
    value: "",
    error: "",
  },
  sessionLink: {
    value: "",
    error: "",
  },
};

function AddCourse() {
  const authData = JSON.parse(localStorage.getItem("p") || "{}");
  const role = authData?.role;
  const navigate = useNavigate();
  const quillRef = useRef(null);
  const [courseData, setCourseData] = useState(initialState);
  const [open, setOpen] = useState({
    general: true,
    configurations: false,
    prerequisites: false,
    system: false,
    lessons: false,
    certificate: false,
  });
  const [modalOpen, setModalOpen] = useState({
    addNewCourse: false,
    addDocument: false,
    certificateTemplate: false,
    addValidity: false,
  });

  const [appliedTemplate, setAppliedTemplate] = useState(
    require("assets/img/certificates/template4.jpg"),
  );
  const [openNestedKey, setOpenNestedKey] = useState(null);
  const toggle = (key) => setOpen((prev) => ({ ...prev, [key]: !prev[key] }));

  const getValidationError = (name, value) => {
    const trimmedValue = typeof value === "string" ? value.trim() : value;
    switch (name) {
      case "courseName":
        return !trimmedValue
          ? "Please enter course name"
          : !REGEX.ONLY_ALPHABETS_REGEX.test(trimmedValue)
            ? "Course name contains invalid characters"
            : "";

      case "category":
        return !value ? "Please select course category" : "";

      case "level":
        return !value ? "Please select course level" : "";

      case "courseDescription":
        return !value ? "Please enter a course description " : "";

      case "courseLanguage":
        return !value || value.length === 0
          ? "Please select course language"
          : "";

      case "address":
        return !value ? "Please select offline training center" : "";

      default:
        return "";
    }
  };

  const validateForm = () => {
    let newCourseData = { ...courseData };

    Object.keys(newCourseData).forEach((key) => {
      newCourseData[key] = {
        ...newCourseData[key],
        error: getValidationError(key, newCourseData[key].value),
      };
    });

    setCourseData(newCourseData);
    return Object.values(newCourseData).every((item) => item.error === "");
  };

  const handleSaveDraft = () => {
    const payload = {
      ...courseData,
      status: "DRAFT",
    };
    navigate("/admin/courses");
  };

  const handleOnCancel = () => {
    setCourseData(initialState);
  };

  const SectionHeader = ({ title, isOpen, onClick }) => (
    <div
      className="d-flex align-items-center cursor text-deep-blue"
      onClick={onClick}
    >
      <i className={`fa fa-chevron-${isOpen ? "up" : "down"}`} />
      <h5 className="ml-2 mb-0 section-header-title">{title}</h5>
    </div>
  );

  //on blur to get if any validation error exits
  const handleOnBlur = (name, value) => {
    const trimmedValue = typeof value === "string" ? value.trim() : value;
    const error = getValidationError(name, trimmedValue);
    setCourseData((prev) => ({
      ...prev,
      [name]: {
        ...prev[name],
        value: trimmedValue,
        error,
      },
    }));
  };

  const handleInputChange = (field, value) => {
    setCourseData((prev) => ({
      ...prev,
      [field]: { value, error: "" },
    }));
  };

  const handleThumbnailChange = (file) => {
    if (!file) return;
    if (file.size > MAX_THUMBNAIL_IMG_SIZE) {
      setCourseData((prev) => ({
        ...prev,
        courseMedia: {
          value: null,
          error: "File size should not exceed 10 MB",
        },
      }));
      return;
    }
    setCourseData((prev) => ({
      ...prev,
      courseMedia: {
        value: file,
        error: "",
      },
    }));
  };

  const handleCourseChange = (selected) => {
    if (!selected) {
      handleInputChange("courseName", "");
      return;
    }
    if (selected.value === "ADD_NEW") {
      // Open modal for adding a new course
      setModalOpen((prev) => ({ ...prev, addCourse: true }));
      return;
    }
    handleInputChange("courseName", selected.value);
  };

  const handleRequiredDocChange = (selectedOptions) => {
    if (!selectedOptions) {
      handleInputChange("requiredDoc", []);
      return;
    }
    // If "Add new document" is clicked
    const isAddNewClicked = selectedOptions.some(
      (opt) => opt.value === "ADD_NEW",
    );
    if (isAddNewClicked) {
      setModalOpen((prev) => ({
        ...prev,
        addDocument: true,
      }));
      return;
    }

    handleInputChange("requiredDoc", selectedOptions);
  };

  const handleValidityChange = (selectedOption) => {
    if (!selectedOption) {
      handleInputChange("validity", "");
      return;
    }
    // Check if "Add New" was clicked
    if (selectedOption.value === "ADD_NEW") {
      setModalOpen((prev) => ({
        ...prev,
        addValidity: true,
      }));
      return;
    }
    // Otherwise, set the selected validity
    handleInputChange("validity", selectedOption.value);
  };

  const DocumentOptions = (props) => {
    const { isSelected, label, data } = props;
    const isAddNew = data.value === "ADD_NEW";

    return (
      <components.Option {...props}>
        <div className="d-flex align-items-center">
          {!isAddNew && (
            <input
              type="checkbox"
              checked={isSelected}
              readOnly
              className="mr-2"
            />
          )}

          <span className={isAddNew ? "text-deep-blue font-weight-bold" : ""}>
            {label}
          </span>
        </div>
      </components.Option>
    );
  };

  const toggleCertificate = () => {
    setModalOpen((prev) => ({
      ...prev,
      certificateTemplate: true,
    }));
  };

  // Called when user applies a template from preview modal inside CertificateTemplateModal
  const handleTemplateApply = (template) => {
    setAppliedTemplate(template);
    setModalOpen((prev) => ({
      ...prev,
      certificateTemplate: false,
    }));
  };
  const handleCancelTemplate = () => {
    setModalOpen((prev) => ({
      ...prev,
      certificateTemplate: false,
    }));
  };

  const handlePublish = () => {
    if (!validateForm()) return;

    const payload = {
      ...courseData,
      status: "PUBLISHED",
      publishedAt: new Date().toISOString(),
    };
    navigate("/admin/courses");
  };

  const createCriteriaOption = () => {
    return function CriteriaOption(props) {
      const { data, isSelected, innerRef, innerProps, selectProps } = props;
      const dependentOptions = selectProps.dependentOptions[data.value];
      const selectedValue = selectProps.criteriaValue[data.value];
      const isOpen = selectProps.openNestedKey === data.value;

      return (
        <div ref={innerRef} {...innerProps} className="px-2 py-1">
          <label className="d-flex align-items-center justify-content-between w-100">
            <div className="d-flex align-items-center">
              <input
                type="checkbox"
                checked={isSelected}
                readOnly
                className="mr-2"
              />

              {data.label}
            </div>
            {dependentOptions && isSelected && (
              <i
                className={`fa fa-angle-${isOpen ? "up" : "down"} ml-2 cursor-pointer`}
                onMouseDown={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  selectProps.setOpenNestedKey(isOpen ? null : data.value);
                }}
              />
            )}
          </label>
          {dependentOptions && isOpen && (
            <div className="ml-4 mt-2 border-left pl-3">
              {dependentOptions.map((opt) => (
                <label
                  key={opt.value}
                  className="d-flex align-items-center mb-1 cursor-pointer"
                  onMouseDown={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    selectProps.onDependentChange(data.value, {
                      label: opt.label,
                      value: opt.value,
                    });
                  }}
                >
                  <input
                    type="radio"
                    name={`criteria-${data.value}`}
                    checked={selectedValue?.value === opt.value}
                    readOnly
                    className="mr-2"
                  />
                  {opt.label}
                </label>
              ))}
            </div>
          )}
        </div>
      );
    };
  };

  const getCriteriaOptionLabel = (criteriaValue) => (option) => {
    const sub = criteriaValue[option.value];
    return sub ? `${option.label} – ${sub.label}` : option.label;
  };

  const handleCriteriaChange = (selected) => {
    const safeSelected = selected || [];
    handleInputChange("completionCriteria", safeSelected);
    // auto-open nested dropdown for last selected item
    const lastSelected = safeSelected[safeSelected.length - 1];
    if (lastSelected && CRITERIA_DEPENDENT_OPTIONS[lastSelected.value]) {
      setOpenNestedKey(lastSelected.value);
    } else {
      setOpenNestedKey(null);
    }
  };

  const courseOptions = coursesList.map((course) => ({
    value: course.title,
    label: course.title,
  }));

  return (
    <>
      <AdminHeader />
      <Container fluid className="mt--6">
        <Row className="justify-content-center">
          <Col>
            <div className="d-flex justify-content-between align-items-center ">
              <div
                className="d-flex align-items-center cursor text-white"
                onClick={() => navigate(-1)}
              >
                <i className="fa-solid fa-angle-left mr-2" />
                <span className="font-weight-bold">Back</span>
              </div>

              <Button
                className="px-4 py-2 btn-vivid-red "
                onClick={handlePublish}
              >
                Publish
              </Button>
            </div>

            {/*general info details*/}
            <Card className="mb-3 mt-3">
              <CardHeader>
                <SectionHeader
                  title="General"
                  isOpen={open.general}
                  onClick={() => toggle("general")}
                />
              </CardHeader>
              <Collapse isOpen={open.general}>
                <CardBody>
                  <Row>
                    <Col md="4">
                      <FormGroup>
                        <Label className="form-control-label">
                          Course Name{" "}
                        </Label>
                        <span className="text-danger"> *</span>
                        <Select
                          name="courseName"
                          options={[...courseOptions, ADD_NEW_COURSE]}
                          placeholder="Select course name"
                          styles={SELECT_CUSTOM_STYLES}
                          classNamePrefix="react-select"
                          value={
                            courseData.courseName.value
                              ? {
                                  value: courseData.courseName.value,
                                  label: courseData.courseName.value,
                                }
                              : null
                          }
                          onChange={handleCourseChange}
                          components={{ Option: DocumentOptions }}
                          onBlur={() =>
                            handleOnBlur(
                              "courseName",
                              courseData.courseName.value,
                            )
                          }
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          className={
                            courseData.courseName.error ? "is-invalid" : ""
                          }
                        />
                        {courseData.courseName.error && (
                          <div className="invalid-feedback d-block">
                            {courseData.courseName.error}
                          </div>
                        )}
                      </FormGroup>
                    </Col>

                    <Col md="4">
                      <FormGroup>
                        <Label className="form-control-label">
                          Course Category
                        </Label>
                        <span className="text-danger"> *</span>
                        <Select
                          name="category"
                          options={COURSE_CATEGORY}
                          placeholder="Select course category"
                          styles={SELECT_CUSTOM_STYLES}
                          classNamePrefix="react-select"
                          value={
                            courseData.category.value
                              ? {
                                  value: courseData.category.value,
                                  label: courseData.category.value,
                                }
                              : null
                          }
                          onChange={(selected) => {
                            handleInputChange("category", selected.value);
                          }}
                          onBlur={(e) =>
                            handleOnBlur("category", e.target.value)
                          }
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          className={
                            courseData.category.error ? "is-invalid" : ""
                          }
                        />
                        {courseData.category.error && (
                          <div className="invalid-feedback d-block">
                            {courseData.category.error}
                          </div>
                        )}
                      </FormGroup>
                    </Col>
                    <Col md="4">
                      <FormGroup>
                        <Label className="form-control-label">
                          Level <span className="text-danger"> *</span>
                        </Label>
                        <Select
                          options={COURSE_LEVELS}
                          placeholder="Select course level"
                          styles={SELECT_CUSTOM_STYLES}
                          classNamePrefix="react-select"
                          value={
                            courseData.level.value
                              ? {
                                  value: courseData.level.value,
                                  label: courseData.level.value,
                                }
                              : null
                          }
                          onChange={(selected) => {
                            handleInputChange("level", selected.value);
                          }}
                          onBlur={(e) => handleOnBlur("level", e.target.value)}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          className={courseData.level.error ? "is-invalid" : ""}
                        />
                        {courseData.level.error && (
                          <div className="invalid-feedback d-block">
                            {courseData.level.error}
                          </div>
                        )}
                      </FormGroup>
                    </Col>

                    <Col md="4" sm="12">
                      <FormGroup>
                        <Label className="form-control-label">
                          Thumbnail Image/Video
                        </Label>

                        <div className="course-upload">
                          <div className="custom-file">
                            <Input
                              type="file"
                              id="courseMedia"
                              className="custom-file-input"
                              accept="image/*,video/*"
                              onChange={(e) => {
                                const file = e.target.files[0];
                                handleThumbnailChange(file);

                                if (file) {
                                  e.target.nextSibling.innerText = file.name;
                                }
                              }}
                            />

                            <Label
                              className="custom-file-label"
                              htmlFor="courseMedia"
                            >
                              Choose file
                            </Label>
                          </div>
                        </div>

                        {courseData.courseMedia.error && (
                          <div className="invalid-feedback d-block">
                            {courseData.courseMedia.error}
                          </div>
                        )}
                      </FormGroup>
                    </Col>

                    <Col md="8">
                      <FormGroup>
                        <Label className="form-control-label">
                          Course Description{" "}
                          <span className="text-danger"> *</span>
                        </Label>

                        <div
                          className={`quill-wrapper ${courseData.courseDescription.error ? "border border-danger rounded" : ""}`}
                        >
                          <ReactQuill
                            theme="snow"
                            modules={MODULES}
                            placeholder="Enter Course Description"
                            value={courseData.courseDescription.value}
                            onChange={(value) =>
                              handleInputChange("courseDescription", value)
                            }
                            onBlur={() =>
                              handleOnBlur(
                                "courseDescription",
                                courseData.courseDescription.value,
                              )
                            }
                          />
                        </div>

                        {courseData.courseDescription.error && (
                          <div className="invalid-feedback d-block">
                            {courseData.courseDescription.error}
                          </div>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>
                </CardBody>
              </Collapse>
            </Card>

            {/* configurations details */}
            <Card className="mb-3">
              <CardHeader>
                <SectionHeader
                  title="Configurations"
                  isOpen={open.configurations}
                  onClick={() => toggle("configurations")}
                />
              </CardHeader>
              <Collapse isOpen={open.configurations}>
                <CardBody>
                  <Row>
                    <Col md="4">
                      <FormGroup check className="p-0">
                        <Label className="form-control-label">
                          Course For <span className="text-danger"> *</span>
                          <InfoPopover
                            targetId="courseForInfo"
                            title="Course For"
                            content="Determines which users can view and enroll in this course."
                          />
                        </Label>

                        <div className="d-flex mt-3">
                          <FormGroup check className="mr-5">
                            <Label check className="cursor">
                              <Input
                                type="radio"
                                name="courseFor"
                                checked={
                                  courseData.courseFor.value === "EXTERNAL"
                                }
                                onChange={() =>
                                  handleInputChange("courseFor", "EXTERNAL")
                                }
                              />
                              External Users
                            </Label>
                          </FormGroup>

                          <FormGroup check className="mr-5">
                            <Label check className="cursor">
                              <Input
                                type="radio"
                                name="courseFor"
                                checked={
                                  courseData.courseFor.value === "RAYCHEM"
                                }
                                onChange={() =>
                                  handleInputChange("courseFor", "RAYCHEM")
                                }
                              />
                              Raychem
                            </Label>
                          </FormGroup>

                          <FormGroup>
                            <Label check className="cursor">
                              <Input
                                type="radio"
                                name="courseFor"
                                checked={courseData.courseFor.value === "BOTH"}
                                onChange={() =>
                                  handleInputChange("courseFor", "BOTH")
                                }
                              />
                              Both
                            </Label>
                          </FormGroup>
                        </div>
                      </FormGroup>
                    </Col>

                    <Col md="4">
                      <FormGroup>
                        <Label className="form-control-label">
                          Course Language
                        </Label>
                        <span className="text-danger"> *</span>
                        <Select
                          isMulti
                          options={COURSE_LANGUAGES}
                          placeholder="Select course language"
                          styles={SELECT_CUSTOM_STYLES}
                          classNamePrefix="react-select"
                          value={courseData.courseLanguage.value}
                          onChange={(selected) => {
                            handleInputChange("courseLanguage", selected);
                          }}
                          onBlur={(e) =>
                            handleOnBlur(
                              "courseLanguage",
                              courseData.courseLanguage.value,
                            )
                          }
                          menuPortalTarget={document.body}
                          components={{ Option: DocumentOptions }}
                          menuPosition="fixed"
                          className={
                            courseData.courseLanguage.error ? "is-invalid" : ""
                          }
                        />
                        {courseData.courseLanguage.error && (
                          <div className="invalid-feedback d-block">
                            {courseData.courseLanguage.error}
                          </div>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="4">
                      <FormGroup>
                        <Label className="form-control-label">
                          Access Type <span className="text-danger"> *</span>
                          <InfoPopover
                            targetId="accessInfo"
                            title="Access Type"
                            content="Select whether learners need to pay to enroll in this course."
                          />{" "}
                        </Label>
                        <div className="d-flex mt-3">
                          <FormGroup check className="mr-5">
                            <Label check className="cursor">
                              <Input
                                type="radio"
                                name="accessType"
                                checked={courseData.accessType.value === "PAID"}
                                onChange={() =>
                                  handleInputChange("accessType", "PAID")
                                }
                              />
                              Paid
                            </Label>
                          </FormGroup>

                          <FormGroup check>
                            <Label check className="cursor">
                              <Input
                                type="radio"
                                name="accessType"
                                checked={courseData.accessType.value === "FREE"}
                                onChange={() =>
                                  handleInputChange("accessType", "FREE")
                                }
                              />
                              Free
                            </Label>
                          </FormGroup>
                        </div>
                      </FormGroup>
                    </Col>

                    {courseData.accessType.value === "PAID" && (
                      <>
                        <Col md="4">
                          <FormGroup>
                            <Label className="form-control-label">
                              Paid For
                              <span className="text-danger"> *</span>
                              <InfoPopover
                                targetId="paidForInfo"
                                title="Paid For"
                                content="Choose which users are required to pay for this course."
                              />
                            </Label>

                            <div className="d-flex mt-3">
                              <FormGroup check className="mr-5">
                                <Label check className="cursor">
                                  <Input
                                    type="radio"
                                    name="paidFor"
                                    checked={
                                      courseData.paidFor.value === "EXTERNAL"
                                    }
                                    onChange={() =>
                                      handleInputChange("paidFor", "EXTERNAL")
                                    }
                                  />
                                  External Users
                                </Label>
                              </FormGroup>

                              <FormGroup check className="mr-5">
                                <Label check className="cursor">
                                  <Input
                                    type="radio"
                                    name="paidFor"
                                    checked={
                                      courseData.paidFor.value === "RAYCHEM"
                                    }
                                    onChange={() =>
                                      handleInputChange("paidFor", "RAYCHEM")
                                    }
                                  />
                                  Raychem
                                </Label>
                              </FormGroup>

                              <FormGroup check className="mr-5">
                                <Label check className="cursor">
                                  <Input
                                    type="radio"
                                    name="paidFor"
                                    checked={
                                      courseData.paidFor.value === "BOTH"
                                    }
                                    onChange={() =>
                                      handleInputChange("paidFor", "BOTH")
                                    }
                                  />
                                  Both
                                </Label>
                              </FormGroup>
                            </div>
                          </FormGroup>
                        </Col>

                        <Col md="4">
                          <Label className="form-control-label">
                            Course Price
                            <span className="text-danger"> *</span>
                          </Label>
                          <div className="mt-2">
                            <FormGroup>
                              <InputGroup>
                                <InputGroupAddon addonType="prepend">
                                  <InputGroupText>
                                    <i class="fa-solid fa-indian-rupee-sign"></i>
                                  </InputGroupText>
                                </InputGroupAddon>
                                <Input
                                  name="price"
                                  value={courseData.coursePrice.value}
                                  placeholder="Enter course price"
                                  onChange={(e) =>
                                    handleInputChange(
                                      "coursePrice",
                                      e.target.value,
                                    )
                                  }
                                />
                              </InputGroup>
                            </FormGroup>
                          </div>
                        </Col>
                      </>
                    )}

                    <Col md="4">
                      <FormGroup>
                        <Label className="form-control-label">
                          Course Type
                          <span className="text-danger"> *</span>
                          <InfoPopover
                            targetId="courseTypeInfo"
                            title="Course Type"
                            content="Defines how the course content is delivered to learners."
                          />
                        </Label>

                        <div className="d-flex mt-3">
                          <FormGroup check className="mr-5">
                            <Label check className="cursor">
                              <Input
                                type="radio"
                                name="courseType"
                                checked={
                                  courseData.courseType.value === "RECORDED"
                                }
                                onChange={() =>
                                  handleInputChange("courseType", "RECORDED")
                                }
                                // disabled
                              />
                              Recorded
                            </Label>
                          </FormGroup>

                          <FormGroup check>
                            <Label check className="cursor">
                              <Input
                                type="radio"
                                name="courseType"
                                checked={courseData.courseType.value === "LIVE"}
                                onChange={() =>
                                  handleInputChange("courseType", "LIVE")
                                }
                              />
                              Live Course
                            </Label>
                          </FormGroup>
                        </div>
                      </FormGroup>
                    </Col>

                    {/* {courseData.courseType.value === "RECORDED" && (
                      <>
                        <Col md="4">
                          <FormGroup>
                            <Label className="form-control-label">
                              Instructor Name
                            </Label>
                            <Select
                              options={trainerOptions}
                              placeholder="Select Instructor"
                              styles={SELECT_CUSTOM_STYLES}
                              classNamePrefix="react-select"
                              value={
                                trainerOptions.find(
                                  (opt) =>
                                    opt.value ===
                                    courseData.instructorName.value,
                                ) || null
                              }
                              onChange={(selected) => {
                                handleInstructorChange(
                                  selected ? selected.value : "",
                                );
                              }}
                              menuPortalTarget={document.body}
                              menuPosition="fixed"
                              className={
                                courseData.instructorName.error
                                  ? "is-invalid"
                                  : ""
                              }
                            />
                            {courseData.instructorName.error && (
                              <div className="invalid-feedback d-block">
                                {courseData.instructorName.error}
                              </div>
                            )}
                          </FormGroup>
                        </Col>
                      </>
                    )} */}
                    {courseData.courseType.value === "LIVE" && (
                      <>
                        <Col md="4">
                          <FormGroup>
                            <Label className="form-control-label">
                              Content Delivery Mode
                              <span className="text-danger"> *</span>
                              <InfoPopover
                                targetId="contentDeliveryInfo"
                                title="Content Delivery Mode"
                                content="Select how this course will be delivered"
                              />
                            </Label>

                            <div className="d-flex mt-3">
                              <FormGroup check className="mr-4">
                                <Label check className="cursor">
                                  <Input
                                    type="radio"
                                    name="liveCourseType"
                                    checked={
                                      courseData.liveCourseType.value ===
                                      "OFFLINE"
                                    }
                                    onChange={() =>
                                      handleInputChange(
                                        "liveCourseType",
                                        "OFFLINE",
                                      )
                                    }
                                  />
                                  Offline
                                </Label>
                              </FormGroup>

                              <FormGroup check className="mr-4">
                                <Label check className="cursor">
                                  <Input
                                    type="radio"
                                    name="liveCourseType"
                                    checked={
                                      courseData.liveCourseType.value ===
                                      "ONLINE"
                                    }
                                    onChange={() =>
                                      handleInputChange(
                                        "liveCourseType",
                                        "ONLINE",
                                      )
                                    }
                                    // disabled
                                  />
                                  Online
                                </Label>
                              </FormGroup>

                              <FormGroup check className="mr-4">
                                <Label check className="cursor">
                                  <Input
                                    type="radio"
                                    name="liveCourseType"
                                    checked={
                                      courseData.liveCourseType.value ===
                                      "HYBRID"
                                    }
                                    onChange={() =>
                                      handleInputChange(
                                        "liveCourseType",
                                        "HYBRID",
                                      )
                                    }
                                    // disabled
                                  />
                                  Online + Offline
                                </Label>
                              </FormGroup>
                            </div>
                          </FormGroup>
                        </Col>

                        {(courseData.liveCourseType.value === "OFFLINE" ||
                          courseData.liveCourseType.value === "HYBRID") && (
                          <Col md="4">
                            <FormGroup>
                              <Label className="form-control-label">
                                Assessment Type{" "}
                                <span className="text-danger">*</span>
                              </Label>

                              <div className="d-flex mt-3">
                                <FormGroup check className="mr-4">
                                  <Label check className="cursor">
                                    <Input
                                      type="radio"
                                      name="assessmentType"
                                      checked={
                                        courseData.assessmentType?.value ===
                                        "TECHNICAL"
                                      }
                                      onChange={() =>
                                        handleInputChange(
                                          "assessmentType",
                                          "TECHNICAL",
                                        )
                                      }
                                    />
                                    Technical
                                  </Label>
                                </FormGroup>

                                <FormGroup check>
                                  <Label check className="cursor">
                                    <Input
                                      type="radio"
                                      name="assessmentType"
                                      checked={
                                        courseData.assessmentType?.value ===
                                        "TECHNICAL_PRACTICAL"
                                      }
                                      onChange={() =>
                                        handleInputChange(
                                          "assessmentType",
                                          "TECHNICAL_PRACTICAL",
                                        )
                                      }
                                    />
                                    Technical + Practical
                                  </Label>
                                </FormGroup>
                              </div>
                            </FormGroup>
                          </Col>
                        )}

                        {(courseData.liveCourseType.value === "OFFLINE" ||
                          courseData.liveCourseType.value === "HYBRID") && (
                          <>
                            <Col md="4">
                              <FormGroup
                                className={`offline-center-wrapper ${
                                  courseData.liveCourseType.value ===
                                    "OFFLINE" ||
                                  courseData.liveCourseType.value === "HYBRID"
                                    ? "show"
                                    : "hide"
                                }`}
                              >
                                <Label className="form-control-label mt-1">
                                  Offline Training Center{" "}
                                  <span className="text-danger">*</span>
                                </Label>
                                <div className="mt-2">
                                  <Select
                                    options={OFFLINE_TRAINING_CENTER}
                                    placeholder="Select offline training center"
                                    styles={SELECT_CUSTOM_STYLES}
                                    classNamePrefix="react-select"
                                    onChange={(selected) =>
                                      handleInputChange("address", selected)
                                    }
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                  />
                                </div>
                              </FormGroup>
                            </Col>
                          </>
                        )}

                        {(courseData.liveCourseType.value === "ONLINE" ||
                          courseData.liveCourseType.value === "HYBRID") && (
                          <Col md="4">
                            <FormGroup
                              className={`offline-center-wrapper ${
                                courseData.liveCourseType.value === "ONLINE" ||
                                courseData.liveCourseType.value === "HYBRID"
                                  ? "show"
                                  : "hide"
                              }`}
                            >
                              <Label className="form-control-label mt-1">
                                Online Session Link{" "}
                                <span className="text-danger">*</span>
                              </Label>
                              <div className="mt-2">
                                <Input
                                  name="price"
                                  value={courseData.sessionLink.value}
                                  placeholder="Enter online session link "
                                  onChange={(e) =>
                                    handleInputChange(
                                      "sessionLink",
                                      e.target.value,
                                    )
                                  }
                                />
                              </div>
                            </FormGroup>
                          </Col>
                        )}

                        {courseData.courseType.value !== "RECORDED" && (
                          <>
                            <Col md="4">
                              <FormGroup>
                                <Label className="form-control-label mt-1">
                                  Min Participants
                                  <InfoPopover
                                    targetId="minParticipantInfo"
                                    title="Min Participants"
                                    content="Sets the minimum number of learners who can enroll."
                                  />
                                </Label>
                                <div className="mt-2">
                                  <Input
                                    name="minParticipant"
                                    value={courseData.minParticipant.value}
                                    placeholder="Enter min participants"
                                    onChange={(e) =>
                                      handleInputChange(
                                        "minParticipant",
                                        e.target.value,
                                      )
                                    }
                                  />
                                </div>
                              </FormGroup>
                            </Col>
                            <Col md="4">
                              <FormGroup>
                                <Label className="form-control-label mt-1">
                                  Max Participants
                                  <InfoPopover
                                    targetId="maxParticipantsInfo"
                                    title="Max Participants"
                                    content="Sets the maximum number of learners who can enroll."
                                  />
                                </Label>
                                <div className="mt-2">
                                  <Input
                                    name="maxParticipant"
                                    value={courseData.maxParticipant.value}
                                    placeholder="Enter max participants"
                                    onChange={(e) =>
                                      handleInputChange(
                                        "maxParticipant",
                                        e.target.value,
                                      )
                                    }
                                  />
                                </div>
                              </FormGroup>
                            </Col>
                          </>
                        )}
                      </>
                    )}
                  </Row>
                </CardBody>
              </Collapse>
            </Card>

            {/* prerequisites details */}
            <Card className="mb-3">
              <CardHeader>
                <SectionHeader
                  title="Prerequisites Documents"
                  isOpen={open.prerequisites}
                  onClick={() => toggle("prerequisites")}
                />
              </CardHeader>

              <Collapse isOpen={open.prerequisites}>
                <CardBody>
                  <Row>
                    <Col md="3">
                      <FormGroup>
                        <Label className="form-control-label">
                          Does this course require prerequisites?
                        </Label>

                        <div className="d-flex mt-3">
                          <FormGroup check className="mr-5">
                            <Label check className="cursor">
                              <Input
                                type="radio"
                                name="preRequisites"
                                checked={
                                  courseData.preRequisites.value === "YES"
                                }
                                onChange={() =>
                                  handleInputChange("preRequisites", "YES")
                                }
                              />
                              Yes
                            </Label>
                          </FormGroup>

                          <FormGroup check>
                            <Label check className="cursor">
                              <Input
                                type="radio"
                                name="preRequisites"
                                checked={
                                  courseData.preRequisites.value === "NO"
                                }
                                onChange={() =>
                                  handleInputChange("preRequisites", "NO")
                                }
                              />
                              No
                            </Label>
                          </FormGroup>
                        </div>
                      </FormGroup>
                    </Col>

                    {courseData.preRequisites.value === "YES" && (
                      <Col md="4">
                        <FormGroup>
                          <Label className="form-control-label">
                            Required Documents
                          </Label>
                          <Select
                            isMulti
                            closeMenuOnSelect={false}
                            hideSelectedOptions={false}
                            options={[
                              ...REQUIRED_DOCUMENTS,
                              ADD_NEW_DOC_OPTION,
                            ]}
                            placeholder="Select required documents"
                            styles={SELECT_CUSTOM_STYLES}
                            classNamePrefix="react-select"
                            value={courseData.requiredDoc.value}
                            onChange={handleRequiredDocChange}
                            components={{ Option: DocumentOptions }}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                          />
                        </FormGroup>
                      </Col>
                    )}
                    <Col md="5">
                      <FormGroup>
                        <Label className="form-control-label">
                          Additional Notes (visible to the trainees during
                          enrollment)
                        </Label>
                        <Input
                          type="textarea"
                          name="notes"
                          rows="1"
                          value={courseData.notes.value}
                          onChange={(e) =>
                            handleInputChange("notes", e.target.value)
                          }
                          onBlur={(e) =>
                            handleOnBlur(e.target.name, e.target.value)
                          }
                          maxLength={300}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                </CardBody>
              </Collapse>
            </Card>

            {/* lessons */}
            <LessonsSection open={open} toggle={toggle} />

            {/* Certificate */}
            <Card className="mb-3">
              <CardHeader>
                <SectionHeader
                  title="Certificate"
                  isOpen={open.certificate}
                  onClick={() => toggle("certificate")}
                />
              </CardHeader>

              <Collapse isOpen={open.certificate}>
                <CardBody>
                  <Row>
                    <Col md="4">
                      <FormGroup>
                        <Label className="form-control-label">
                          Certificate Enabled
                        </Label>

                        <div className="d-flex mt-3">
                          <FormGroup check className="mr-5">
                            <Label check>
                              <Input
                                type="radio"
                                name="certificateEnabled"
                                checked={
                                  courseData.certificateEnabled.value === "YES"
                                }
                                onChange={() =>
                                  handleInputChange("certificateEnabled", "YES")
                                }
                              />
                              Yes
                            </Label>
                          </FormGroup>

                          <FormGroup check>
                            <Label check>
                              <Input
                                type="radio"
                                name="certificateEnabled"
                                checked={
                                  courseData.certificateEnabled.value === "NO"
                                }
                                onChange={() =>
                                  handleInputChange("certificateEnabled", "NO")
                                }
                              />
                              No
                            </Label>
                          </FormGroup>
                        </div>
                      </FormGroup>
                    </Col>
                    <Col md="4">
                      <FormGroup>
                        <Label className="form-control-label">
                          Certificate Issuance Criteria
                        </Label>
                        <Select
                          placeholder="Select course criteria"
                          isMulti
                          closeMenuOnSelect={false}
                          hideSelectedOptions={false}
                          options={COMPLETION_CRITERIA}
                          value={courseData.completionCriteria.value}
                          onChange={handleCriteriaChange}
                          components={{ Option: createCriteriaOption() }}
                          openNestedKey={openNestedKey}
                          setOpenNestedKey={setOpenNestedKey}
                          dependentOptions={CRITERIA_DEPENDENT_OPTIONS}
                          criteriaValue={courseData.criteriaValue.value}
                          onDependentChange={(key, value) => {
                            handleInputChange("criteriaValue", {
                              ...courseData.criteriaValue.value,
                              [key]: value,
                            });
                          }}
                          styles={SELECT_CUSTOM_STYLES}
                          classNamePrefix="react-select"
                          menuPortalTarget={document.body}
                          getOptionLabel={getCriteriaOptionLabel(
                            courseData.criteriaValue.value,
                          )}
                        />
                      </FormGroup>
                    </Col>

                    <Col md="4">
                      <FormGroup>
                        <Label className="form-control-label">
                          Certificate Validity
                        </Label>
                        <Select
                          options={[...VALIDITY, ADD_NEW_VALIDITY_OPTION]}
                          placeholder="Select validity"
                          styles={SELECT_CUSTOM_STYLES}
                          classNamePrefix="react-select"
                          value={
                            courseData.validity.value
                              ? {
                                  value: courseData.validity.value,
                                  label: courseData.validity.value,
                                }
                              : null
                          }
                          onChange={handleValidityChange}
                          components={{ Option: DocumentOptions }}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12">
                      <FormGroup>
                        <Label className="form-control-label">
                          Certificate Template
                        </Label>

                        <div className="certificate-template d-flex align-items-start">
                          {/* Left actions */}
                          <div className="d-flex flex-column mr-2">
                            <Button
                              color="secondary"
                              className="mb-3 ml-4 mt-3 btn1"
                              onClick={toggleCertificate}
                            >
                              <i className="fa fa-edit mr-2" />
                              Change Template
                            </Button>

                            <Button
                              color="secondary"
                              className="ml-4 btn1"
                              onClick={(e) => e.preventDefault()}
                            >
                              <i className="fa fa-download mr-2" />
                              Download
                            </Button>
                          </div>

                          {/* Template preview */}
                          <div className="certificate-preview">
                            <img
                              src={appliedTemplate}
                              alt="Certificate Template"
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </Col>
                  </Row>
                </CardBody>
              </Collapse>
            </Card>

            <Row className="mt-4 mr-4 mb-5">
              <Col className="text-right">
                <Button
                  color="secondary"
                  className="mr-2 px-4 py-2"
                  type="button"
                  onClick={handleOnCancel}
                >
                  Cancel
                </Button>
                <Button
                  color="light"
                  className=" mr-2 px-4 py-2 text-dark"
                  type="button"
                  onClick={() =>
                    navigate("/admin/course/add-course/preview", {
                      state: {
                        courseData, // from this data
                        lessons, // from LessonsSection
                      },
                    })
                  }
                >
                  Preview
                </Button>

                <Button
                  color="primary"
                  className="btn-deep-blue mr-2 px-4 py-2"
                  type="submit"
                  onClick={() => {
                    handleSaveDraft();
                  }}
                >
                  Save Draft
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>

      <AddDocumentModal
        isOpen={modalOpen.addCourse}
        toggle={() => setModalOpen((prev) => ({ ...prev, addCourse: false }))}
        title="Add New Course"
        label="Course Name"
        onSave={(val) => {
          // Add new course to your course options dynamically
          const newCourseOption = { value: val, label: val };
          courseOptions.push(newCourseOption); // so it appears in dropdown
          handleInputChange("courseName", val); // select it immediately
          setModalOpen((prev) => ({ ...prev, addCourse: false }));
        }}
      />

      <AddDocumentModal
        isOpen={modalOpen.addDocument}
        toggle={() => setModalOpen((prev) => ({ ...prev, addDocument: false }))}
        title="Add Document"
        label="Document Name"
        onSave={(val) => {
          // Add new document to options
          REQUIRED_DOCUMENTS.push({ label: val, value: val });
          handleInputChange("requiredDoc", [
            ...courseData.requiredDoc.value,
            { label: val, value: val },
          ]);
        }}
      />

      <AddDocumentModal
        isOpen={modalOpen.addValidity}
        toggle={() => setModalOpen((prev) => ({ ...prev, addValidity: false }))}
        title="Add Course Validity"
        label="Validity"
        onSave={(val) => {
          // Add new validity before the +Add option
          VALIDITY.splice(VALIDITY.length - 1, 0, { label: val, value: val });
          handleInputChange("validity", val);
        }}
      />

      <CertificateTemplateModal
        isOpen={modalOpen.certificateTemplate}
        toggle={handleCancelTemplate}
        selectedTemplate={appliedTemplate} // current applied template
        onSelect={handleTemplateApply} // selected template from preview popup
      />
    </>
  );
}

export default AddCourse;
